const pad = (value: number): string => String(value).padStart(2, "0");

/** Converts API UTC ISO string to `datetime-local` input value (local timezone). */
export const utcIsoToDatetimeLocalValue = (iso: string): string => {
  const date = new Date(iso);

  if (Number.isNaN(date.getTime())) {
    return "";
  }

  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

/** Converts `datetime-local` input value to UTC ISO for API payloads. */
export const datetimeLocalValueToUtcIso = (value: string): string => {
  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return "";
  }

  return date.toISOString();
};

/** Converts `date` input (YYYY-MM-DD) to UTC ISO at start/end of local day. */
export const localDateToUtcDayRange = (
  dateValue: string
): { start: string; end: string } => {
  const start = new Date(`${dateValue}T00:00:00`);
  const end = new Date(`${dateValue}T23:59:59`);

  return {
    start: start.toISOString(),
    end: end.toISOString(),
  };
};

/** Formats UTC ISO for display in lists (local timezone). */
export const formatUtcIsoForDisplay = (
  iso: string,
  locale: string,
  options: Intl.DateTimeFormatOptions = { dateStyle: "short", timeStyle: "short" }
): string => {
  const date = new Date(iso);

  if (Number.isNaN(date.getTime())) {
    return iso;
  }

  return new Intl.DateTimeFormat(locale, options).format(date);
};
